import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';
import useRouterMatch from './useRouterMatch';

export const dailyAbuseLimitKey = ['dailyAbuseLimit'];

const useDailyAbuseLimit = () => {
  const { tenantId: activeTenantId } = useRouterMatch();

  const { data, isLoading } = useQuery({
    queryKey: dailyAbuseLimitKey,
    queryFn: () => backendService.instance.users.getDailyAbuseLimit(),
    refetchInterval: 1000 * 60 * 5,
    staleTime: 1000 * 60 * 4,
    enabled: !!activeTenantId,
  });

  return {
    data,
    isLoading,
    isBlocked: data?.blocked ?? false,
  };
};

export default useDailyAbuseLimit;
